import { FirebaseApp, initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { Firestore, initializeFirestore } from 'firebase/firestore';
import { getDatabase } from 'firebase/database';
import { getAnalytics } from 'firebase/analytics';

import { APP_INSTANCE_NAME } from 'common/config/constants';

/**
 * Firebase Service is singleton class to work with Firebase (Auth, Cloud Storage, Cloud Firestore)
 */
export class FirebaseService {

  private static _instance: FirebaseService;
  private readonly _app: FirebaseApp;
  private _isFirestoreConfigured: boolean = false;
  private _firestore: Firestore;

  private constructor() {

    const config = {
      apiKey: process.env.REACT_APP_FIREBASE_SDK_API_KEY,
      authDomain: process.env.REACT_APP_AUTH_DOMAIN,
      databaseURL: process.env.REACT_APP_DATABASE_URL,
      projectId: process.env.REACT_APP_PROJECT_ID,
      storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
      messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
      measurementId: process.env.REACT_APP_MEASUREMENT_ID,
      appId: process.env.REACT_APP_APP_ID
    };

    this._app = initializeApp(config, APP_INSTANCE_NAME);
  }

  /**
   * Get the Firebase Singleton service instance
   * @returns
   */
  public static get instance() {
    if (!this._instance) {
      this._instance = new FirebaseService();
    }

    return this._instance;
  }

  /**
   * Get the current Firebase App instance
   */
  public get app() {
    return this._app;
  }

  /**
   * Get Firebase Authentication service
   */
  public get auth() {
    const auth = getAuth(this.app);

    return auth;
  }

  /**
   * Get Firebase Storage service
   */
  public get storage() {
    return getStorage(this._app);
  }

  /**
   * Get Firebase Firestore service
   */
  public get firestore() {
    if (!this._isFirestoreConfigured) {
      this._firestore = initializeFirestore(this._app, {
        ignoreUndefinedProperties: true
      });

      return this._firestore;
    } else return this._firestore;
  }

  /**
   * Get Realtime Database service
   */
  public get database() {
    return getDatabase(this._app);
  }

  /**
   * Get Firebase Analytics service
   */
  public get analytics() {
    return getAnalytics(this._app);
  }

}